import { ShareIcon } from '@/components/Icon/ShareIcon'
import { useRouterBack } from '@/hooks/useRouterBack'
import { IconBackDark } from '@/styles/Icon'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect, useState } from 'react'
interface HeaderProductDetailType {
  layout: string
  dataHeader: string | undefined
  visible?: boolean
  setIsOpenShare: Dispatch<SetStateAction<boolean>>
}
const HeaderProductDetail = ({
  layout,
  dataHeader,
  visible = true,
  setIsOpenShare,
}: HeaderProductDetailType) => {
  const handleGoBack = useRouterBack()
  const [scrollY, setScrollY] = useState(0)

  const handleScroll = () => {
    setScrollY(document.documentElement.scrollTop)
  }
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll)
      return () => window.removeEventListener('scroll', handleScroll)
    }
  })

  return (
    <header
      className={`${layout ? layout : ''} ${
        visible ? 'visible' : 'invisible'
      } ${
        scrollY > 25 ? 'bg-white fixed' : 'absolute'
      } left-[50%] translate-x-[-50%] top-0 z-[999] flex  w-full max-w-[440px] flex-wrap`}
    >
      <div className='flex h-[48px] w-full items-center justify-between'>
        <div className='flex-[40px] max-w-[40px]'>
          <button
            className='h-10 w-10 outline-none flex justify-center items-center cursor-pointer relative z-10'
            onClick={() => handleGoBack(true)}
          >
            <IconBackDark />
          </button>
        </div>
        {scrollY > 25 && (
          <div className='flex-1 w-full px-1'>
            <h1 className='text-headingMedium break-all text-dark-800 overflow-hidden text-ellipsis  line-clamp-1'>
              {dataHeader}
            </h1>
          </div>
        )}
        {scrollY > 25 && (
          <div className='flex-[40px] max-w-[40px]'>
            <button
              className='h-10 w-10 outline-none flex justify-center items-center'
              onClick={() => setIsOpenShare(true)}
            >
              <ShareIcon />
            </button>
          </div>
        )}
      </div>
    </header>
  )
}
export { HeaderProductDetail }
